export const KYB_NATURE_OF_OPERATIONS_OPTIONS = {
  CORE_BANKING: 'core_banking',
  INVOICING: 'invoicing',
  SPEND_MANAGEMENT: 'spend_management',
  BOOK_KEEPING: 'book_keeping',
  REMUNERATION: 'remuneration',
  CASHFLOW_MANAGEMENT: 'cashflow_management',
  PAYROLL_REIMBURSEMENT: 'payroll_reimbursement',
} as const;
